import { createRef, useRef } from 'react'
import { useConstructor } from './'

const useFormTemplate = formTemplate => {
  const fieldRefs = useRef([])
  useConstructor(() => {
    if (formTemplate) {
      for (let i = 0; i < formTemplate.length; ++i) {
        fieldRefs.current.push(createRef())
      }
    }
  })
  return fieldRefs.current
}

export default useFormTemplate